import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import endpoint from "../../config/endpoints";
import { serverMsg } from "../../config/messageconstant";
import { imageUrl } from "../../config/Url";
import promoterDetailsStyles from "../../Styles/promoterDetails";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

// ---------------------------------------------------------------------------
// Styled Dialog
// ---------------------------------------------------------------------------
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": { padding: theme.spacing(2) },
}));

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose && (
            <IconButton onClick={onClose} sx={promoterDetailsStyles.closeIcon}>
                <CloseIcon />
            </IconButton>
        )}
    </DialogTitle>
);

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

// ---------------------------------------------------------------------------
// Item Component
// ---------------------------------------------------------------------------
const Item = ({ item, index }) => {
    // Open image in new tab
    const onPressImage = (img) => {
        if (!img) return;
        window.open(imageUrl + img, "_blank");
    };

    // Get matched option titles
    const getSelectedOptionTitles = () => {
        if (!item.auditQuestionOptionValue || !item.options) return [];

        return item.options
            .filter((opt) =>
                item.auditQuestionOptionValue.includes(String(opt.id))
            )
            .map((opt) => opt.optionTitle);
    };

    return (
        <div style={promoterDetailsStyles.itemCard}>
            <div style={promoterDetailsStyles.itemInner}>
                {/* Question */}
                <div style={promoterDetailsStyles.questionRow}>
                    <TypographyCompo sx={promoterDetailsStyles.questionText}>
                        {index + 1}. {item.question}
                    </TypographyCompo>
                </div>

                {/* Options */}
                {item.optionType !== 0 && getSelectedOptionTitles().length > 0 && (
                    <div style={{ padding: "0 10px 10px" }}>
                        {getSelectedOptionTitles().map((title, i) => (
                            <div key={i} style={promoterDetailsStyles.optionCard}>
                                <TypographyCompo sx={promoterDetailsStyles.optionText}>{title}</TypographyCompo>
                            </div>
                        ))}
                    </div>
                )}

                {/* Images */}
                {item.images?.length > 0 && (
                    <div style={promoterDetailsStyles.imageRow}>
                        {item.images.map((img, idx) => (
                            <div
                                key={idx}
                                style={promoterDetailsStyles.imageThumbWrapper}
                                onClick={() => onPressImage(img)}
                            >
                                <img
                                    src={imageUrl + img}
                                    alt="img"
                                    style={promoterDetailsStyles.thumbnail}
                                />
                            </div>
                        ))}
                    </div>
                )}

                {/* Remark */}
                {item.remark && item.images?.length == 0 && (
                    <div style={promoterDetailsStyles.remarkRow}>
                        <TypographyCompo sx={promoterDetailsStyles.remarkLabel}>Answer :</TypographyCompo>
                        <TypographyCompo sx={promoterDetailsStyles.remarkValue}>{item.remark}</TypographyCompo>
                    </div>
                )}
            </div>
        </div>
    );
};

// ---------------------------------------------------------------------------
// Main Component
// ---------------------------------------------------------------------------
const PromoterDataPopUp = ({
    handleCloses,
    showLoador,
    showNotification,
    outletOrderHeaderId,
    itemObject,
}) => {
    const [auditViewList, setAuditViewList] = React.useState([]);
    const [popUpOpenFlag, setPopUpOpenFlag] = React.useState(false);

    React.useEffect(() => {
        if (outletOrderHeaderId) {
            fetchData();
        }
    }, [outletOrderHeaderId]);

    const fetchData = async () => {
        if (!navigator.onLine) {
            showNotification({ msg: serverMsg, severity: "error" });
            return;
        }

        showLoador({ loador: true });

        const { data, success } = await apiGet({
            url:
                endpoint.audit +
                "/get-audit-transaction-details-by-header?auditTransactionHeaderId=" +
                outletOrderHeaderId,
        });

        showLoador({ loador: false });

        if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
            return;
        }

        const formattedData =
            data?.data?.auditTransaction?.auditTransactionDetails?.map((q) => ({
                question: q.auditQuestion.question,
                optionType: q.auditQuestion.optionType,
                remark: q.remark,
                images: q.images ? q.images.split(",") : [],
                options: q.auditQuestion.auditQuestionOption || [],
                auditQuestionOptionValue:
                    q.auditQuestionOptionValue && q.auditQuestionOptionValue.trim() !== ""
                        ? q.auditQuestionOptionValue.split(",").map(String)
                        : [],
            })) || [];

        setAuditViewList(formattedData);
        setPopUpOpenFlag(true);
    };

    return (
        <BootstrapDialog
            onClose={handleCloses}
            open={popUpOpenFlag}
            fullWidth
            maxWidth="md"
        >
            <BootstrapDialogTitle onClose={handleCloses}>
                <div style={promoterDetailsStyles.headerContainer}>

                    <TypographyCompo sx={promoterDetailsStyles.headerTitle}>
                        Promoter Details
                    </TypographyCompo>

                    <TypographyCompo sx={promoterDetailsStyles.headerSubTitle}>
                        {itemObject?.entityName || ""}
                    </TypographyCompo>


                </div>
            </BootstrapDialogTitle>

            <div style={promoterDetailsStyles.noteContainer}>
                <TypographyCompo sx={promoterDetailsStyles.noteText}>
                    Note: Click on image to open in new tab
                </TypographyCompo>
            </div>


            <DialogContent dividers>
                {auditViewList.length === 0 ? (
                    <div style={promoterDetailsStyles.emptyMsg}>No questions found.</div>
                ) : (
                    auditViewList.map((item, index) => (
                        <Item key={index} item={item} index={index} />
                    ))
                )}
            </DialogContent>
        </BootstrapDialog>
    );
};

const mapDispatchToProps = { showLoador, showNotification };

export default connect(null, mapDispatchToProps)(PromoterDataPopUp);

